import { GOD_POSTS } from "@/mocks/home";
import Reveal from "./Reveal";
import SectionHead from "./SectionHead";

export default function GodPosts() {
  return (
    <section id="god" className="w-full bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <Reveal>
          <SectionHead
            index="04"
            kicker="Archive"
            title="神贴仓库 · 镇站之选"
            desc="收藏级的经典长帖与补档神贴，完整搬运、标清出处，想一口气读完的那种。"
            action="翻阅神贴仓库"
          />
        </Reveal>

        <div className="mt-8 flex flex-col gap-8">
          {GOD_POSTS.map((g, i) => {
            const flip = i % 2 === 1;
            return (
              <Reveal key={g.id} delay={i * 60}>
                <article className="group grid grid-cols-1 items-center gap-5 lg:grid-cols-12 lg:gap-8">
                  <div className={`lg:col-span-5 ${flip ? "lg:order-2" : ""}`}>
                    <div className="relative h-56 w-full overflow-hidden rounded-lg md:h-64">
                      <img
                        src={g.image}
                        alt={`海角网神贴搬运：${g.title}`}
                        title={`${g.title} · 海角网神贴`}
                        className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
                      <span className="absolute left-4 top-4 font-heading text-6xl font-black text-background-50/90 md:text-7xl">
                        {String(g.id).padStart(2, "0")}
                      </span>
                    </div>
                  </div>

                  <div className={`lg:col-span-7 ${flip ? "lg:order-1" : ""}`}>
                    <div className="flex items-center gap-2 text-xs font-black uppercase tracking-[0.16em] text-primary-500">
                      <i className="ri-stack-fill" />
                      神贴 #{String(g.id).padStart(2, "0")}
                    </div>
                    <h3 className="editorial-title mt-2 text-xl font-black leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-2xl">
                      {g.title}
                    </h3>
                    <p className="mt-3 max-w-xl text-sm leading-[1.9] text-foreground-600">{g.excerpt}</p>
                    <div className="mt-4 flex flex-wrap items-center gap-3">
                      <span className="rounded-full bg-accent-50 px-3 py-1 text-xs font-bold text-accent-700">{g.stats}</span>
                      <span className="text-xs text-foreground-500">补档自天涯热帖与论坛原串，已标注整理说明</span>
                    </div>
                    <div className="mt-5 flex flex-wrap items-center gap-3">
                      <a
                        href="#faq"
                        className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-foreground-800"
                      >
                        整篇开读
                        <i className="ri-book-open-line" />
                      </a>
                      <button
                        type="button"
                        className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-foreground-950/15 px-5 py-2.5 text-sm font-bold text-foreground-800 transition-colors hover:bg-secondary-100"
                      >
                        <i className="ri-heart-3-line" />
                        收藏这篇
                      </button>
                    </div>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}